/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineBriefcase, HiOutlinePencil } from "react-icons/hi";

import ListPage from "../../layout/ListPage";
import type { Action, Column } from "../../ui";
import { useStaticContext } from "../../context/StaticContext";
import { pushOneService } from "../../lib/sysNavigation/SysNavigation";

type ServiceRow = {
  service_id: number | string;
  title?: string;
  description?: string;
  [key: string]: unknown;
};

const editRoute = "/service/edit";

const Overview: React.FC = () => {
  const navigate = useNavigate();
  const { service, fetchService } = useStaticContext() as any;

  useEffect(() => {
    if (!service) fetchService();
  }, [service]);

  const rows = useMemo<ServiceRow[] | null>(() => {
    if (!Array.isArray(service)) return null;
    return service as ServiceRow[];
  }, [service]);

  const columns: Column<ServiceRow>[] = [
    {
      header: "Title",
      cell: (row) => (
        <span className="font-medium text-gray-900">{row.title ?? "—"}</span>
      ),
    },
    {
      header: "Description",
      cell: (row) => (
        <span className="line-clamp-2 text-gray-600">{row.description ?? "—"}</span>
      ),
    },
  ];

  const rowActions = (row: ServiceRow): Action[] => [
    {
      label: "Edit",
      icon: <HiOutlinePencil className="h-3.5 w-3.5" />,
      onClick: () => {
        pushOneService(row);
        navigate(editRoute);
      },
    },
  ];

  return (
    <ListPage<ServiceRow>
      title="Services"
      subtitle="Services listed on the public site."
      icon={<HiOutlineBriefcase className="h-5 w-5" />}
      rows={rows}
      columns={columns}
      rowKey={(r) => r.service_id}
      rowActions={rowActions}
      empty="No services yet."
    />
  );
};

export default Overview;
